import type { HeadlineResponse } from '@on3/api';
import { On3Icon5GoatsIconFull } from '@on3/icons';
import { useSite } from '@on3/ui-lib/contexts/SiteProvider';
import { MobileMPU } from '@public/components/Ads/MobileMPU';
import { MPU } from '@public/components/Ads/MPU';
import { CoverList } from '@public/components/Headlines/ArticleCover/CoverList';
import { FeedList } from '@public/components/Headlines/ArticleFeed/FeedList';
import { FeedListAlternate } from '@public/components/Headlines/ArticleFeedAlternate/FeedListAlternate';
import { SEOHomeText } from '@public/components/Home/SEOHomeText';
import { HomeLayout } from '@public/components/Layouts/HomeLayout';

import styles from './ProHome.module.scss';

const nflViewAll = [
  {
    url: 'pro/category/nfl/news/',
    text: 'View All NFL',
    title: 'NFL News',
  },
];
const nflDraftViewAll = [
  {
    url: 'pro/category/nfl-draft/news/',
    text: 'View All NFL Draft',
    title: 'NFL Draft News',
  },
];
const nascarViewAll = [
  {
    url: 'pro/category/nascar/news/',
    text: 'View All NASCAR',
    title: 'NASCAR News',
  },
];
const proViewAll = [
  {
    url: 'pro/news/',
    text: 'View All Pro',
    title: 'Pro News',
  },
];
const sportsBettingViewAll = [
  {
    url: 'pro/category/sports-betting/news/',
    text: 'View All Sports Betting',
    title: 'Sports Betting News',
  },
];

export interface ProHomePageProps {
  latestArticles: HeadlineResponse[] | null;
  nascarArticles: HeadlineResponse[] | null;
  nflArticles: HeadlineResponse[] | null;
  nflDraftArticles: HeadlineResponse[] | null;
  sportsBettingArticles: HeadlineResponse[] | null;
}

export const ProHome = ({
  latestArticles,
  nascarArticles,
  nflArticles,
  nflDraftArticles,
  sportsBettingArticles,
}: ProHomePageProps) => {
  const coverArticles = latestArticles?.slice(0, 3);
  const { currentSite } = useSite();
  const siteColor = currentSite?.primaryColor || '#fe3b1f';

  return (
    <>
      {!!coverArticles?.length && (
        <CoverList
          backgroundColor={siteColor}
          categoryColor={'#6f747b'}
          list={coverArticles}
        />
      )}
      <SEOHomeText>
        <On3Icon5GoatsIconFull className={styles.metaIcon} />
        <h1>
          Pro sports media, just enough culture and the juice from the immortal
          5 GOATs. Powered by On3.
        </h1>
      </SEOHomeText>
      <HomeLayout>
        <section className={styles.feed}>
          <div className={styles.inner}>
            {!latestArticles?.length || (
              <FeedList
                list={latestArticles.slice(3, 15)}
                section="Pro News"
                viewAllLinks={proViewAll}
              />
            )}
            <MobileMPU id={'mobile_mpu_top'} incontent />
          </div>
        </section>
        <aside className={styles.sidebarright}>
          <div className={styles.inner}>
            <MPU id={'mpu_top'} />
            <FeedListAlternate
              list={nascarArticles?.slice(0, 5)}
              section="NASCAR News"
              viewAllLinks={nascarViewAll}
            />

            <FeedListAlternate
              list={nflDraftArticles?.slice(0, 5)}
              section="NFL Draft News"
              viewAllLinks={nflDraftViewAll}
            />
            <MPU id={'mpu_middle'} />
            <MobileMPU id={'mobile_mpu_middle'} incontent />
          </div>
        </aside>
        <aside className={styles.sidebarleft}>
          <div className={styles.inner}>
            <FeedListAlternate
              list={sportsBettingArticles?.slice(0, 5)}
              section="Sports Betting News"
              viewAllLinks={sportsBettingViewAll}
            />
            <FeedListAlternate
              list={nflArticles?.slice(0, 5)}
              section="NFL News"
              viewAllLinks={nflViewAll}
            />
          </div>
        </aside>
      </HomeLayout>
    </>
  );
};
